import { authMode } from "@/data/authMode";
import { useLogOutMutation, useSelfUserQuery } from "@/data/queries";
import { redirectToAuthAppLogin } from "@/data/requests";
import cn from "@/util/cn";
import { ComponentProps, ComponentPropsWithoutRef, PropsWithChildren } from "react";
import { useNavigate } from "react-router";
import Link from "./Link";

type NavigationProps = ComponentPropsWithoutRef<"nav">;

const Navigation = ({ className, ...otherProps }: NavigationProps) => {
  const navigate = useNavigate();
  const { data: user } = useSelfUserQuery();
  const { mutate: logout } = useLogOutMutation();
  return (
    <nav
      className={cn(
        "static top-0 flex w-full flex-row items-center justify-between gap-4",
        className
      )}
      {...otherProps}
    >
      <Link to="/" className="shrink-0">
        <img src="/logo.svg" alt="Bloomlife logo" className="h-6" />
      </Link>
      {user && (
        <ul className="flex flex-row items-center justify-end gap-6 text-primary/90">
          <li>
            <NavItem
              href="/"
              icon="logout"
              className="overflow-visible text-nowrap"
              onClick={() => {
                if (authMode === "cookie") {
                  logout({}, { onSettled: redirectToAuthAppLogin });
                } else {
                  logout({});
                  navigate("/login");
                }
              }}
            >
              Sign out
              <span className="pl-1 text-sm">
                ({user.displayName ?? `${user.firstName} ${user.lastName}`})
              </span>
            </NavItem>
          </li>
        </ul>
      )}
    </nav>
  );
};

type NavItemProps = {
  href: string;
  icon: string;
} & Omit<ComponentProps<typeof Link>, "to">;

const NavItem = ({ href, icon, children, ...otherProps }: PropsWithChildren<NavItemProps>) => {
  return (
    <Link to={href} {...otherProps}>
      <span className="material-icons pr-1 align-middle">{icon}</span>
      {children}
    </Link>
  );
};

export default Navigation;
